import React from "react";
import { motion } from "framer-motion";
import { Linkedin, Mail, Crown, Gem, Code2 } from "lucide-react";

const team = [
  {
    id: "kamlesh",
    name: "Kamlesh Kumar Sinha",
    role: "Founder",
    Icon: Crown,
    email: "Dmaskut@gmail.com",
  },
  {
    id: "srivastava",
    name: "K. Srivastava",
    role: "Founding Member",
    Icon: Gem,
    email: "Dmaskut@gmail.com",
  },
  {
    id: "buxi",
    name: "Buxi Uttam Sinha",
    role: "Developer",
    Icon: Code2,
    email: "Dmaskut@gmail.com",
  },
];

const TeamCard = ({ m, index }) => {
  const { Icon } = m;
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.55, delay: index * 0.08, ease: [0.22, 1, 0.36, 1] }}
      data-testid="team-member-card"
      className="group relative rounded-3xl glass-strong p-8 md:p-10 flex flex-col items-center text-center hover:-translate-y-1.5 transition-transform duration-500"
    >
      <div className="relative">
        {/* gradient ring */}
        <div
          className="absolute -inset-[3px] rounded-full transition-transform duration-500 group-hover:rotate-[18deg]"
          style={{
            background: "conic-gradient(from 0deg, #00B4F0, #0A82D8, #00B4F0)",
          }}
        />
        {/* inner circle with icon */}
        <div
          className="relative h-28 w-28 md:h-32 md:w-32 rounded-full overflow-hidden bg-white flex items-center justify-center shadow-[0_10px_30px_-10px_rgba(10,130,216,0.35)] transition-transform duration-500 group-hover:scale-[1.06]"
        >
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 + index * 0.1, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
            className="flex items-center justify-center"
          >
            <Icon
              className="h-12 w-12 md:h-14 md:w-14 text-[#0A82D8] transition-transform duration-500 group-hover:-translate-y-0.5"
              strokeWidth={1.75}
            />
          </motion.div>
        </div>
        {/* ambient glow on hover */}
        <div
          aria-hidden
          className="absolute -inset-5 rounded-full blur-2xl opacity-30 group-hover:opacity-80 transition-opacity duration-500 -z-10"
          style={{
            background: "radial-gradient(circle, rgba(0,180,240,0.55), transparent 65%)",
          }}
        />
      </div>

      <h3 className="mt-6 font-display font-semibold text-lg md:text-xl tracking-tight">
        {m.name}
      </h3>
      <span className="mt-1 text-[11px] tracking-[0.22em] uppercase text-muted-foreground">
        {m.role}
      </span>

      <div className="mt-5 flex items-center gap-2 opacity-0 group-hover:opacity-100 translate-y-1 group-hover:translate-y-0 transition-all duration-400">
        <a
          href={`mailto:${m.email}`}
          aria-label={`Email ${m.name}`}
          className="h-9 w-9 rounded-full glass flex items-center justify-center hover:bg-[#00B4F0] hover:text-white transition-colors"
        >
          <Mail className="h-4 w-4" />
        </a>
        <a
          href="https://linkedin.com"
          target="_blank"
          rel="noreferrer"
          aria-label={`LinkedIn ${m.name}`}
          className="h-9 w-9 rounded-full glass flex items-center justify-center hover:bg-[#0A82D8] hover:text-white transition-colors"
        >
          <Linkedin className="h-4 w-4" />
        </a>
      </div>
    </motion.div>
  );
};

const Team = () => {
  return (
    <section
      id="team"
      data-testid="team-section"
      className="relative py-24 md:py-32"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl mb-14 text-center mx-auto"
        >
          <span className="text-xs font-semibold tracking-[0.22em] uppercase text-[#0A82D8]">
            The team
          </span>
          <h2 className="mt-3 font-display font-semibold text-4xl md:text-5xl lg:text-[3.25rem] tracking-tighter leading-[1.05]">
            The people you'll actually <br className="hidden sm:block" />
            <span className="text-gradient-cyan">be working with.</span>
          </h2>
          <p className="mt-4 text-base md:text-lg text-muted-foreground">
            A small team on purpose. You'll know everyone's name in the first week.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 max-w-5xl mx-auto">
          {team.map((m, i) => (
            <TeamCard key={m.id} m={m} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;
